// Table empty-state messages. Change a text here to update it everywhere.
// empty: the table has no records / search: a search or filter returned no results
export type EmptyStateMessage = { empty: string; search?: string };

export const EMPTY_STATE_MESSAGES = {
  // Notes tables (Ride, Standing Order, Member, Contractor, Segment Details, Profile)
  notes: {
    empty: 'No Notes Found',
    search: 'No Notes Found matching your search',
  },
  // Ride Assignment / Contractor Portal - Assignment grid
  assignmentGrid: {
    empty: 'No Rides Assigned for the selected date of service',
    search: 'No Rides Found matching your search',
  },
  // Ride Assignment / Contractor Portal - Assignment History tab
  assignmentHistory: {
    empty: 'No Assignment History Found',
    search: 'No Assignment History Found matching your search',
  },
  // Ride Assignment / Contractor Portal - Transmit History tab
  transmitHistory: {
    empty: 'No Transmit History Found',
    search: 'No Transmit History Found matching your search',
  },
  // Ride Assignment - Contractor panel
  contractors: {
    empty: 'No Contractors Found',
    search: 'No Contractors Found matching your search',
  },
  // Contractor Portal - Ride Marketplace tab
  rideMarketplace: {
    empty:
      'No Rides Available in the Ride Marketplace for the selected date of service',
    search: 'No Rides Found in the Ride Marketplace matching your search',
  },
  // Standing Order lists (Member / Contractor Rides tab, Contractor Portal)
  standingOrders: {
    empty: 'No Standing Orders Found',
    search: 'No Standing Orders Found matching your search',
  },
  // Contractor Portal - Notifications screen (no search or filter)
  notifications: {
    empty: 'No Notifications Found',
  },
  // Header - Notifications dropdown (no search or filter)
  notificationsDropdown: {
    empty: 'No Notifications',
  },
  // Audit Log tables (Ride, Standing Order, Segment, Contractor, Profile)
  auditLog: {
    empty: 'No Audit Log Records Found',
    search: 'No Audit Log Records Found matching your search',
  },
  // Contractor Management - Level of Service tab
  levelOfService: {
    empty: 'No Level of Service Records Found',
    search: 'No Level of Service Records Found matching your search',
  },
  // Contractor Management / Member - Rides tab
  rides: {
    empty: 'No Rides Found',
    search: 'No Rides Found matching your search',
  },
  // Member - Eligibility Transactions
  eligibility: {
    empty: 'No Eligibility Records Found',
    search: 'No Eligibility Records Found matching your search',
  },
  // Ride Monitoring - Monitoring grid
  monitoring: {
    empty: 'No Rides Found for the selected date of service',
    search: 'No Rides Found matching your search',
  },
  // Reporting Dashboard - View Data tables (report tables have no search box)
  reportData: {
    empty: 'No Report Data Found for the selected filters',
  },
  // Reporting Dashboard - See Rides tables (report tables have no search box)
  reportRides: {
    empty: 'No Rides Found for the selected filters',
  },
  // Profile & Activity - Recent Activity tab (no search or filter)
  recentActivity: {
    empty: 'No Recent Activity Found',
  },
  // Profile & Activity - Permissions tab
  permissions: {
    empty: 'No Permissions Found',
    search: 'No Permissions Found matching your search',
  },
  // Admin - Users table
  users: {
    empty: 'No Users Found',
    search: 'No Users Found matching your search',
  },
  // Admin - Roles / Permissions tables
  roles: {
    // empty: 'No Roles Found',
    empty: 'No Permissions Found',
    // search: 'No Roles Found matching your search',
    search: 'No Permissions Found matching your search',
  },
} satisfies Record<string, EmptyStateMessage>;
